export default __webpack_public_path__ + "static/media/01.9236a80f.jpg";